import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 16px;
	min-width: 460px;

	@media (max-width: 520px) {
		min-width: auto;
	}
`;

export const Content = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 15px;
	line-height: 1.6;
	max-height: 420px;
	overflow-y: auto;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: ${({ theme }) => theme.colors.text.title};
		margin: 1em 0 0.5em;
		font-size: 1.05em;
	}

	p {
		margin: 0 0 1em 0;
	}

	ul,
	ol {
		margin: 0 0 1em 1.25em;
		padding-left: 1em;
	}

	li {
		margin-bottom: 0.5em;
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 24px;
`;

